import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDownloads, deleteDownload } from './documentsActions';
import { DownloadItem, DownloadsResponse } from 'interfaces/downloads';

interface DownloadsState {
    downloads: DownloadItem[];
    processing: string[];
    loading: boolean;
    error: any | null;
}

const initialState: DownloadsState = {
    downloads: [],
    loading: false,
    error: null,
    processing: [],
};

const downloadsSlice = createSlice({
    name: 'downloads',
    initialState,
    reducers: {
        addProcessing: (state, action: PayloadAction<string>) => {
            state.processing = [...state.processing, action.payload];
        },
        removeProcessing: (state, action: PayloadAction<string>) => {
            state.processing = state.processing.filter(sig => sig !== action.payload);
        },
        clearDownloads: (state) => {
            state.downloads = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDownloads.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDownloads.fulfilled, (state, action: PayloadAction<DownloadsResponse>) => {
                state.loading = false;
                state.downloads = action.payload;
            })
            .addCase(fetchDownloads.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteDownload.pending, (state, action) => {
                state.processing = [...state.processing, action.meta.arg];
            })
            .addCase(deleteDownload.fulfilled, (state, action) => {
                if (action.payload) {
                    state.processing = state.processing.filter(sig => sig !== action.payload!.signature);
                    // Remove the download from the list if successful
                    state.downloads = state.downloads.filter(d => d.signature !== action.payload!.signature);
                }
            })
            .addCase(deleteDownload.rejected, (state, action) => {
                if (action.payload && typeof action.payload === 'object' && 'signature' in action.payload) {
                    state.processing = state.processing.filter(sig => sig !== (action.payload as any).signature);
                }
            })
    },
});

export const { addProcessing, removeProcessing, clearDownloads } = downloadsSlice.actions;
export default downloadsSlice.reducer;
